import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { TGetAuthorArticlesSucceed, EGetAuthorArticlesActionType } from './types';
import { TAuthorArticlesItem } from '../../../types/authorArticles';

export const getAuthorArticlesSucceed: (items: TAuthorArticlesItem[]) => TGetAuthorArticlesSucceed = actionGenerator<
  EGetAuthorArticlesActionType.Succeed,
  TAuthorArticlesItem[]
>(EGetAuthorArticlesActionType.Succeed);
